var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavourite = function SvgFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.727 2a2.273 2.273 0 0 0-2.272 2.273v13.636a2.273 2.273 0 0 0 2.272 2.273h5.736a5.929 5.929 0 0 1-.98-1.364H4.728a.91.91 0 0 1-.909-.909h5.285a5.885 5.885 0 0 1-.268-1.363H3.818V4.273a.91.91 0 0 1 .91-.91h10.454a.91.91 0 0 1 .909.91V9.29c.472.036.929.127 1.363.268V4.273A2.273 2.273 0 0 0 15.182 2H4.727Zm.455 3.636a.91.91 0 0 1 .909-.909h7.273a.91.91 0 0 1 .909.91v1.818a.91.91 0 0 1-.91.909H6.092a.91.91 0 0 1-.91-.91V5.637ZM6.545 7h6.364v-.91H6.545V7Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.636 22a5.909 5.909 0 1 0 0-11.818 5.909 5.909 0 0 0 0 11.818Zm-2.841-1.998 2.841-1.494 2.842 1.494-.543-3.164 2.3-2.241-3.178-.462-1.42-2.879-1.421 2.879-3.178.462 2.3 2.24-.543 3.165Z",
    fill: "#666"
  })));
};
export default SvgFavourite;